var React = require('react');

function Like (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#a)","fill":"#212121","key":0},React.createElement("path",{"d":"M4 11H1a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h3V11Zm18.539-.6A4 4 0 0 0 19.5 9H13V4c0-2.206-.794-4-3-4a1 1 0 0 0-.965.737L6 11v13h12.426a3.979 3.979 0 0 0 3.954-3.392l1.076-7a4 4 0 0 0-.917-3.208Z"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"fill":"#fff","d":"M0 0h24v24H0z"})))]);
}

Like.defaultProps = {"width":"16","height":"16","viewBox":"0 0 24 24","fill":"none"};

module.exports = Like;

Like.default = Like;
